import { Outlet } from "react-router-dom";
import { DepositWithdrawProvider } from "src/contexts";
import { RouteGuard } from "src/components";

const DepositWithdrawalShared: React.FC = () => {
  return (
    <RouteGuard>
      <DepositWithdrawProvider>
        <Outlet />
      </DepositWithdrawProvider>
    </RouteGuard>
  );
};

export default DepositWithdrawalShared;
